var React = require('react');

function LogoSymbolInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M29.2244 24.3132L17.2478 31.2263V17.4L29.2244 24.3132ZM12.8605 33.761L2.18049 39.9278L2.64586 40.7356C6.66732 47.7015 15.5707 50.0868 22.5366 46.0654L39.1639 36.4654L33.6117 26.8478L44.2946 33.0146L44.76 32.2068C48.7815 25.2439 46.3961 16.3376 39.4303 12.3161L22.8029 2.7161L17.2507 12.3337V0H16.32C8.27415 0 1.7561 6.51805 1.7561 14.561V33.761H12.8605Z","fill":"black"}));
}

LogoSymbolInline.defaultProps = {"width":"48","height":"49","viewBox":"0 0 48 49","fill":"none"};

module.exports = LogoSymbolInline;

LogoSymbolInline.default = LogoSymbolInline;
